import { render, staticRenderFns } from "./manager.vue?vue&type=template&id=b524e442&"
import script from "./manager.vue?vue&type=script&lang=js&"
export * from "./manager.vue?vue&type=script&lang=js&"
import style0 from "./manager.vue?vue&type=style&index=0&id=b524e442&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports